var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rk-chart-num b"},[_c('span',[_vm._v(_vm._s((_vm.avg || 0).toFixed(2)))]),_c('span',{staticClass:"rk-chart-num-unit"},[_vm._v(_vm._s(_vm.unit))])])}
var staticRenderFns = []

export { render, staticRenderFns }